<section class="featured-promotions">
    <div class="container px-sm-4 px-lmd-2">
        <div class="d-flex justify-content-center">
            <img
                [alt]="'featured promotions'"
                class="featprom-img"
                [src]="'images/img_promociones.webp' | cdn"
            />
        </div>
        <div
            class="container_titles d-flex justify-content-between flex-column flex-slmd-row align-items-center"
        >
            <h2 class="title_block">
                {{
                    'fe_promotionsblock_h2_title_featured-promotions'
                        | translate
                }}
            </h2>
            <a
                [routerLink]="'promos-and-agreements' | formatUrl"
                class="link_seemore"
                >{{ 'fe_promotionsblock_link_see-all-promotions' | translate
                }}<img
                    class="arrow_link"
                    alt="arrow link"
                    [src]="'images/flecha_links_amarilla.svg' | cdn"
            /></a>
        </div>

        <div class="row g-4">
            <ng-container *ngIf="isloading; else promotionsContent">
                <div
                    *ngFor="let placeholder of placeholders"
                    class="col-sm-12 col-lmd-3 px-2-5 d-flex flex-column"
                >
                    <div class="placeholder placeholder-wave"></div>
                </div>
            </ng-container>

            <ng-template #promotionsContent>
                <ng-container *ngIf="promotions.length > 0; else noPromotions">
                    <fe-card-promotion
                        *ngFor="let promotion of promotions"
                        [promotion]="promotion"
                        class="col-sm-12 col-lmd-3 px-2-5"
                    ></fe-card-promotion>
                </ng-container>

                <!-- Sin promociones -->
                <ng-template #noPromotions>
                    <div class="col-12">
                        <p style="text-align: center; color: white">
                            {{ 'fe_no_promotions_available' | translate }}
                        </p>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
</section>
